import { Box } from '@mui/material';
import { Logo } from '@src/components/logo';
import { FC } from 'react';
import { COLORS, SiteTheme } from '~/themes';

/**
 * O logo importa direto de components/logo, e não do barrel de components,
 * para não arrastar a cadeia inteira de componentes do main-app para o bundle
 * de uma tela que só desenha um SVG.
 */
const SiteIndex: FC = () => (
  <SiteTheme>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: COLORS.primary.main,
      }}
    >
      <Logo width={280} opacity={0.85} />
    </Box>
  </SiteTheme>
);

export default SiteIndex;
